import { gql } from "@apollo/client"

export const FORGET_PASSWORD = gql`
    mutation requestPasswordReset($input: RequestPasswordResetInput!) {
        requestPasswordReset (input: $input) {
            clientMutationId
        }
    }
`;